import { Popover, Typography, TypographyProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import Colors from '../../../layout/theme/utils/colors';

export const StyledPopover = styled(Popover)(({ theme }) => ({
  '& .MuiPaper-root': {
    padding: theme.spacing(2),
    marginTop: theme.spacing(0.5),
    backgroundColor: Colors.white,
    boxShadow: `4px 4px 8px 4px ${Colors.blue_bell}`,
    right: theme.spacing(1.25),
    width: '560px',
  },
}));

export const Heading = styled(Typography)<TypographyProps>(({ theme }) => ({
  color: Colors.dark_gray,
}));

export const FormDetails = styled('span')(({ theme }) => ({
  color: Colors.bright_grey,
  paddingLeft: theme.spacing(0.5),
}));

export const OptionsList = styled('ul')(({ theme }) => ({
  listStyle: 'none',
  paddingLeft: 0,
  margin: theme.spacing(1, 0.5, 0.5, 0.5),
}));

export const ListItem = styled('li')(({ theme }) => ({
  marginBottom: theme.spacing(1),
}));

export const ListItemLabel = styled('span')(() => ({
  fontSize: '13px',
  color: Colors.dark_gray,
}));

export const ListItemValue = styled('span')(({ theme }) => ({
  marginLeft: theme.spacing(0.5),
}));

export const DisabledButtonStyles = {
  backgroundColor: Colors.whitest_grey,
  color: Colors.gray,
  cursor: 'not-allowed',
  '&:hover': {
    backgroundColor: Colors.whitest_grey,
  },
};

export const iconStyles = {
  width: 16,
  height: 16,
  color: Colors.light_slate_blue,
};

export const buttonIconStyles = (theme) => ({
  paddingLeft: 0,
  paddingRight: theme.spacing(0.25),
});
